import PropTypes from 'prop-types';
import { DayPicker as ReactDayPicker, Day } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import classes from './DayPicker.module.css';
import { es, enUS } from 'date-fns/locale';
import { format } from 'date-fns';
import clsx from 'clsx';
import CustomDay from './CustomDay';
import { useTranslation } from 'react-i18next';

const capilitize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const CaptionLabel = ({ displayMonth }) => {
    const { i18n } = useTranslation();
    const locale = i18n.language === 'ES' ? es : enUS;

    const monthFormatted = format(displayMonth, 'MMMM yyyy', { locale });
    const month = capilitize(monthFormatted);

    return <div className={classes.captionLabel}>{month}</div>;
};

CaptionLabel.propTypes = {
    displayMonth: PropTypes.instanceOf(Date).isRequired,
};

export default function DayPicker(props) {
    const { mode = 'single', className, enabledDays, ...dayPickerProps } = props;

    const { i18n } = useTranslation();
    const locale = i18n.language === 'ES' ? es : enUS;

    const DayComponent = Array.isArray(enabledDays)
        ? (props) => <CustomDay {...props} enabledDays={enabledDays} />
        : Day;

    return (
        <ReactDayPicker
            locale={locale}
            className={clsx(classes.dayPicker, className)}
            classNames={{
                cell: classes.cell,
                head_cell: classes.headCell,
            }}
            mode={mode}
            components={{
                CaptionLabel,
                Day: DayComponent,
            }}
            showOutsideDays
            {...dayPickerProps}
        />
    );
}

DayPicker.propTypes = {
    mode: PropTypes.oneOf(['single', 'range']),
    onChange: PropTypes.func,
    month: PropTypes.instanceOf(Date),
    onMonthChange: PropTypes.func,
    selected: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.shape({
            from: PropTypes.instanceOf(Date),
            to: PropTypes.instanceOf(Date),
        }),
    ]),
    onSelect: PropTypes.func,
    className: PropTypes.string,
    enabledDays: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
};
